// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';


// TODO: Color border & backgnround from theme
const boxedStyle = theme => (css`
  background-color: ${theme.review.backgroundColor};
  border-radius: 6px;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, .3);
  margin-top: .25rem;
  padding: 2rem;
`);

// TODO: Color border & backgnround from theme
const outlinedStyle = theme => (css`
  background-color: ${theme.review.backgroundColor};
  border: 1px solid ${props => props.theme.review[props.template || 'default'].borderColor};
  border-radius: 6px;
  padding: 1.5rem 2rem;
`);

export default styled<any, Theme>('article')`
  ${props => props.variant === 'boxed' && boxedStyle(props.theme)}
  ${props => props.variant === 'outline' && outlinedStyle(props.theme)}

  .review-list {
    border-top: 1px solid ${props => props.theme.review[props.template || 'default'].borderColor};
    margin-top: 1.5rem;
    padding: .5rem 0 0;
    li {
      color:${props => props.theme.review[props.template || 'default'].textRatingColor};
    }
  }
`;
